import Footer from "../../component/Footer";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import AgentNavbar from "../../component/AgentNavbar";
import { ChevronRight, User, LogOut, Key, Eye, EyeOff } from "react-feather"; // Importing Eye and EyeOff icons
import { baseurl } from "../../component/Baseurl";
import axios from 'axios';
import Swal from 'sweetalert2';  // Import SweetAlert2

function AgentChangePassword() {
  const [formData, setFormData] = useState({
    password: '',
    confirmPassword: ''
  });
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false); // State for showing password
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true); // Initially hide submit button

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if passwords match
    if (formData.password !== formData.confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    const agentid = localStorage.getItem("agent_id");

    try {
      const response = await axios.put(`${baseurl}updateAgentPassword/${agentid}`, {
        password: formData.password
      });

      if (response.data.message === "Password updated successfully") {
        Swal.fire({
          title: 'Success!',
          text: 'Password updated successfully!',
          icon: 'success',
          confirmButtonText: 'OK'
        });
      }
    } catch (error) {
      setError('Failed to update password');
      Swal.fire({
        title: 'Error!',
        text: 'Failed to update password. Please try again later.',
        icon: 'error',
        confirmButtonText: 'OK'
      });
    }
  };

  // Check if passwords match and enable submit button
  useEffect(() => {
    if (formData.password && formData.confirmPassword && formData.password === formData.confirmPassword) {
      setIsSubmitDisabled(false);
      setError(''); // Reset error if passwords match
    } else {
      setIsSubmitDisabled(true);
    }
  }, [formData]);

  // Toggle show password visibility
  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <>
      <AgentNavbar />
      <div className="bgagent">
        <div className="container-fluid">
          <div className="d-flex justify-content-between align-items-center">
            <h1 className="text-start agenth1 pt-3 font4">
              <span>My Profile</span>
            </h1>

            <span className="text-muted">
              Dashboard <ChevronRight size={12} /> Change Password
            </span>
          </div>

          <div className="row g-3">
            <div className="col-md-3">
              <div className="crdmain">
                <div>
                  <Link to="/my-profile">
                    <div className="menu1 mb-1"><User size={16} /> My Profile</div>
                  </Link>
                  <Link to="/change-password">
                    <div className="menu1 mb-1 activetab"><Key size={16} /> Change Password</div>
                  </Link>
                  <Link>
                    <div className="menu1 mb-1"><LogOut size={16} /> Logout</div>
                  </Link>
                </div>
              </div>
            </div>

            <div className="col-md-9">
              <div className="crdmain p-3">
                <form className="text-start" onSubmit={handleSubmit}>
                  <div className="row g-2 mt-4 mb-4">
                    <div className="col-md-8">
                      <label className="text-dark mb-1 labelset2 font3">Password</label>
                      <div className="position-relative">
                        <input
                          type={showPassword ? "text" : "password"} // Show/hide password
                          className="input1"
                          name="password"
                          value={formData.password}
                          onChange={handleInputChange}
                          placeholder="Enter Password.."
                          required
                        />
                        <div
                          className="position-absolute"
                          style={{ top: '50%', right: '10px', transform: 'translateY(-50%)' }}
                          onClick={toggleShowPassword}
                        >
                          {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                        </div>
                      </div>
                    </div>

                    <div className="col-md-8">
                      <label className="text-dark mb-1 labelset2 font3">Confirm Password</label>
                      <div className="position-relative">
                        <input
                          type={showPassword ? "text" : "password"} // Show/hide password
                          className="input1"
                          name="confirmPassword"
                          value={formData.confirmPassword}
                          onChange={handleInputChange}
                          placeholder="Enter Confirm Password.."
                          required
                        />
                        <div
                          className="position-absolute"
                          style={{ top: '50%', right: '10px', transform: 'translateY(-50%)' }}
                          onClick={toggleShowPassword}
                        >
                          {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                        </div>
                      </div>
                    </div>
                  </div>

                  {error && <div className="text-danger">{error}</div>}  {/* Error message */}
                  <div className="mb-4 text-end">
                    <button type="submit" className="submit-btn mt-3" disabled={isSubmitDisabled}>Update</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default AgentChangePassword;
